import React from 'react'
import HelpHeader from './HelpHeader'
import HelpInner from './HelpInner'

function HelpController() {
  return (
    <React.Fragment>
      <HelpHeader />
      <HelpInner />
    </React.Fragment>
  )
}

export default React.memo(HelpController)
